import Vue from 'vue'

// 字符串截取，默认8个字符
Vue.filter('filterName', (str, len = 8) => {    
  if (str && str.length > len) {
    str = `${str.substr(0, len)}...`
  } 
  return str 
})

// 时间过滤
Vue.filter('formatTime', (time, fmt) => {
  if (typeof time == 'string' && time.constructor == String) {
    time = time.toString().replace(/-/g, '/')
  }
  const d = new Date(time)  
  const o = {
    'M+': d.getMonth() + 1, // 月份
    'd+': d.getDate(), // 日
    'h+': d.getHours(), // 小时
    'm+': d.getMinutes(), // 分
    's+': d.getSeconds(), // 秒
    'q+': Math.floor((d.getMonth() + 3) / 3), // 季度
    S: d.getMilliseconds() // 毫秒
  }
  // eslint-disable-next-line prefer-template
  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (d.getFullYear() + '').substr(4 - RegExp.$1.length)) }
  for (const k in o) { 
    // eslint-disable-next-line prefer-template
    if (new RegExp('(' + k + ')').test(fmt)) {
      // eslint-disable-next-line prefer-template
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) 
    } 
  }
  return fmt
})

// 取金额整数部分
Vue.filter('filterIntPrice', (number) => {
  if (number == 0 || number == -1) return '0'
  number = number.toFixed(2)
  const pointIndex = number.indexOf('.')
  return number.substr(0, pointIndex)
})

// 取金额小数部分
Vue.filter('filterDotPrice', (number) => {
  if (number == 0 || number == -1) return '.00'
  number = number.toFixed(2)
  const pointIndex = number.indexOf('.')
  const a = number.split('.')
  if (a[1] > 0) {
    return number.substr(pointIndex)
  // eslint-disable-next-line no-else-return
  } else {
    return '.00'
  }
})

// 校验是否支持webp
const isSupportWebp = (() => {
  let supportWebp = false
  try {
    const ele = document.createElement('object')
    ele.type = 'image/webp'
    ele.innerHTML = '!'
    document.body.appendChild(ele)
    // 如果浏览器支持webp,那么这个object是不可见的(offsetWidth为0),
    // 否则就会显示出来,有可视宽度.
    supportWebp = !ele.offsetWidth
    document.body.removeChild(ele)
  } catch (err) {
    supportWebp = false
  }
  return supportWebp
})()

// 取金额小数部分
Vue.filter('filterWebp', (imgUrl) => {
  // 一些有可能传入空字符串
  if (!imgUrl) {
    return imgUrl
  }
  // gif不能转换成webp
  if (imgUrl.includes('.gif')) {
    return imgUrl
  }

  try {
    // 没有document相当于在服务器执行，先假定支持webp  否则在初始化渲染模板的时候要加载一遍正常的图片再加载一遍webp的图片
    if (isSupportWebp) {
      const interfaceKeyWord = ['imageslim', 'imageView2', 'imageMogr2', 'imageInfo', 'exif', 'watermark', 'imageAve']
      const notProcessed = interfaceKeyWord.every(keyword => imgUrl.indexOf(keyword) === -1)
      if (notProcessed) {
        imgUrl += '?imageMogr2/format/webp'
      } else {
        imgUrl += '|imageMogr2/format/webp'
      }
    }
    return imgUrl
  } catch (e) {
    return imgUrl
  }
})


